import React from "react";
import {
  Target,
  Shield,
  Smartphone,
  RefreshCw,
  Users,
  Ship,
} from "lucide-react";
import { Card, CardContent } from "./ui/card";

const services = [
  {
    icon: Target,
    title: "Strategic Sourcing",
    description:
      "Identify optimal suppliers, negotiate favorable terms, and establish strategic partnerships that drive value and reduce costs.",
  },
  {
    icon: Shield,
    title: "Governance, Risk & Compliance",
    description:
      "Implement robust frameworks to manage procurement risk, ensure compliance, and maintain transparent governance across your supply chain.",
  },
  {
    icon: Smartphone,
    title: "Digital Procurement",
    description:
      "Leverage modern technology and digital tools to automate processes, enhance visibility, and enable data-driven decision making.",
  },
  {
    icon: RefreshCw,
    title: "Procurement Transformation",
    description:
      "Redesign your procurement function from the ground up with strategic initiatives that align with business objectives and drive long-term value.",
  },
  {
    icon: Users,
    title: "Hands-on Procurement Support",
    description:
      "Founder-led, practical support for day-to-day procurement activities, providing experienced guidance when you need it most.",
  },
  {
    icon: Ship,
    title: "Cross Border Sourcing and Delivery",
    description:
      "Expert on-ground support for China sourcing of capital equipment, machinery and critical infrastructure ensuring integrity, transparency and seamless passage of inventory to destination port.",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      className="py-24 px-4 sm:px-6 lg:px-8 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Procurement Solutions
          </h2>
          <p className="text-xl text-gray-600">
            End-to-end services designed to optimize your procurement operations
            and drive business performance
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <Card
                key={service.title}
                className="border-2 border-gray-100 hover:border-[#1e3a8a] transition-all duration-300 hover:shadow-xl group"
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#1e3a8a] transition-colors duration-300">
                    <Icon className="w-7 h-7 text-[#1e3a8a] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-4">
            Not sure which service fits your needs?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById("contact");
              if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-[#1e3a8a] font-semibold hover:underline inline-flex items-center gap-2"
          >
            Let's discuss your requirements
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};